var quantityLabel = "Antall";
var quantityFlyoutHeader = "Velg antall";
var quantityFlyoutCTA = "Velg dette antallet";
var closeButton = "Lukk";
var pricePlaceholder = "...";
var priceLabel = "Pris";
var unitPriceLabel = "Enhetspris";
var incompatibilityMessage = "Ikke tilgjengelig med andre valg: ";
var select = "Velg...";
var percentSavings = "{{{PERCENT}}} % besparelse";
var sale = "salg";
var amountSavings = "{{{AMOUNT}}} besparelse/enhet";
var amountSavingsWithSale = "{{{AMOUNT}}} besparelse/enhet + salg";
var seeMoreQuantities = "Se flere antall";
var required = "Obligatorisk";
var sample = "Prøve";
var estimatedQuantity = "Estimert antall";
var numberOfRecipients = "{{{COUNT}}} Mottakere";
var recommendedCallout = "Anbefalt";
var newCallout = "Nyhet";
var incompatibleLabel = "Uforenlig";
var outOfStockCallout = "Utsolgt";
var dismissAlert = "Avvis varsel";
var unwindingMessage_1 = "Uforenlig med {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "Uforenlig med {{{ATTRIBUTE1}}} {{{OPTION1}}} og {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "Uforenlig med {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} og {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "Uforenlig med mer enn {{{ATTRIBUTE_COUNT}}} alternativer.";
var unwindingAlertMessage_1 = "Å være forenlig med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} ble valgt bort.";
var unwindingAlertMessage_2 = "Å være forenlig med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} og {{{ATTRIBUTE2}}} {{{OPTION2}}} ble valgt bort.";
var unwindingAlertMessage_3 = "Å være forenlig med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} og {{{ATTRIBUTE3}}} {{{OPTION3}}} ble valgt bort.";
var unwindingAlertMessage_more = "Å være forenlig med {{{ATTRIBUTE}}} {{{OPTION}}}: Mer enn {{{ATTRIBUTE_COUNT}}} alternativer ble valgt bort.";
var fullRangedHelperText = "{{{MINIMUM}}} {{{UNIT}}} til {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Minst {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Skriv inn en verdi mellom {{{MINIMUM}}} og {{{MAXIMUM}}} sider, inkludert omslag ";
var rangePartialRangedHelperTextForBooklets = "Minst {{{MINIMUM}}} sider, inkludert omslag ";
var rangedGeneralInputError = "Inndata er ugyldig";
var rangedBetweenRangesError = "De nærmeste tallene er {{{LOWER}}} {{{UNIT}}} og {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "Tallet kan ikke ha mer enn 8 desimaler";
var rangedMinInputValueError = "Minimumsantall er {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "Maksimalt antall er {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "Inndata må være et tall";
var requiredAttributeFieldError = "Skriv inn en verdi mellom {{{LOWER}}} og {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "De nærmeste antallene er {{{LOWER}}} sider og {{{HIGHER}}} sider ";
var rangedMinInputValueErrorForBooklets = "Minimumsantall er {{{MINIMUM}}} sider ";
var rangedMaxInputValueErrorForBooklets = "Maksimalt antall er {{{MAXIMUM}}} sider ";
var requiredAttributeFieldErrorForBooklets = "Skriv inn en verdi mellom {{{LOWER}}} og {{{HIGHER}}} sider, inkludert omslag ";
var requiredInformationToast = "Angi alle opplysninger som kreves.";
var nbNo = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, nbNo as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=nb-no.json.mjs.map
